import Link from "@material-ui/core/Link";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";

const Footer = () => {
  return (
    <Box
      style={{ position: "fixed", bottom: 0, left: 0, right: 0, background: "white", padding: "10px" }}
      // elevation={3}
    >
      <Typography variant="body2" color="textSecondary" align="center">
        {"Copyright © "}
        <Link color="inherit" href="https://globalflow.com.vn/">
          Petrolimex Aviation JSC -
        </Link>{" "}
        {new Date().getFullYear()}
        {"."}
      </Typography>
    </Box>
  );
};
export default Footer;
